export default "__VITE_ASSET__D8XN3p3n__"